import React from 'react'
import { LoginPanelStyle as Wrapper } from '../style'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Form, Icon, Input, Button, Alert } from 'antd'
import styled from 'styled-components'

import { loginWithLegacy } from '../store/actions'
import { loginWithUsername, loadLoginProfile } from '../../../api/auth'

const FormItem = Form.Item
const LoginForm = styled.div`
  margin: 2rem auto;

  #components-form-demo-normal-login .login-form {
    max-width: 300px;
  }
  #components-form-demo-normal-login .login-form-forgot {
    float: right;
  }
  #components-form-demo-normal-login .login-form-button {
    width: 100%;
  }
`

class NonSSOLogin extends React.Component {
  state = {
    isLoading: false,
    isError: false
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.processLogin(values.username, values.password)
      }
    })
  }

  processLogin = async (username, password) => {
    const { loginWithLegacy } = this.props

    this.setState({ isLoading: true, isError: false })
    try {
      const response = await loginWithUsername(username, password)
      const profile = await loadLoginProfile(response.access_token)

      this.setState({ isLoading: false })
      loginWithLegacy({
        account: response,
        user: profile
      })
    }
    catch(e) {
      this.setState({ isLoading: false, isError: true })
    }
  }

  render() {
    const { isLogin } = this.props
    const { getFieldDecorator } = this.props.form

    if (isLogin) {
      return <Redirect to={'/search'} />
    }

    return (
      <Wrapper>
        <div className="container">
          <div className="logo">
            <div className="image">
              <img src={process.env.REACT_APP_OVERRIDE_IMAGE ? process.env.REACT_APP_OVERRIDE_IMAGE : '/images/logo256x256.png'} alt="logo"/>
            </div>
            <div className="title">{ process.env.REACT_APP_NAME }</div>
            <div className="detail">เข้าสู่ระบบจัดการสมาชิก</div>
          </div>

          { this.state.loginError ? (
            <div>
              <br/>
              <Alert
                message="ไม่สามารถเข้าสู่ระบบได้"
                description="รหัสผู้ใช้หรือรหัสผ่านไม่ถูกต้อง"
                type="error"
              />
            </div>
          ) : null}
        
          <LoginForm>
            <Form onSubmit={this.handleSubmit} className="login-form">
              <FormItem>
                {getFieldDecorator('username', {
                  rules: [{ required: true, message: 'กรุณาระบุชื่อผู้ใช้งาน' }],
                })(
                  <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="ชื่อผู้ใช้งาน" />
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('password', {
                  rules: [{ required: true, message: 'กรุณาระบุรหัสผ่าน' }],
                })(
                  <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="รหัสผ่าน" />
                )}
              </FormItem>
              <FormItem style={{textAlign: 'center'}}>
                <Button type="primary" loading={this.state.isLoading || this.state.localLoading } icon={'lock'} size="large" htmlType="submit">
                  เข้าสู่ระบบ
                </Button>
              </FormItem>
            </Form>
          </LoginForm>

          { process.env.REACT_APP_OVERRIDE_HIDE_LICENCE === true ? (
            <div className="footer">
              <div className="link">
                <a href="https://www.privageapp.com/terms" rel="noopener noreferrer" target="_blank">เงื่อนไขการใช้งาน</a> &nbsp;|&nbsp;  
                <a href="https://www.privageapp.com/privacy" rel="noopener noreferrer" target="_blank">นโยบายความเป็นส่วนตัว</a>
              </div>
              <div className="licence">&copy; 2018 Privage App Co.,Ltd.</div>
            </div>
          ) : null }
        </div>
      </Wrapper>
    )
  }
}

export default connect(state => ({
  isLogin: state.auth.accessToken != null,
  auth: state.auth
}), {
  loginWithLegacy
})(Form.create()(NonSSOLogin))



// WEBPACK FOOTER //
// ./src/containers/Auth/components/NonSSOLogin.js